<template>
  <div ref="rangeslider" class="form-control-range"></div>
</template>

<script>
import noUiSlider from 'nouislider'
import 'nouislider/distribute/nouislider.css'
import '@/styles/components/range-slider.less'

export default {
  name: 'RangeSlider',
  props: {
    start: {
      type: Array,
      required: true
    },
    step: {
      type: [Number, String],
      required: false,
      default: 1
    },
    min: {
      type: Number,
      required: false,
      default: 0
    },
    max: {
      type: Number,
      required: false,
      default: 100
    },
    colors: {
      type: Array,
      required: false
    }
  },
  data: () => ({
    rangeSlider: null
  }),
  mounted() {
    if (!this.$refs.rangeslider) {
      return
    }
    this.initRangeSlider()
  },
  beforeDestroy() {
    if (!this.rangeSlider) {
      return
    }
    this.rangeSlider.destroy()
  },
  watch: {
    start() {
      this.rangeSlider.set(this.start)
    }
  },
  computed: {
    connectArray() {
      return Array(this.start.length + 1).fill(true)
    }
  },
  methods: {
    initRangeSlider() {
      this.rangeSlider = noUiSlider.create(this.$refs.rangeslider, {
        range: {
          min: this.min,
          max: this.max
        },
        start: this.start,
        step: this.step,
        connect: this.connectArray
      })
      this.rangeSlider.on('update', this.updateValue)
      this.colorizedSlider()
    },
    updateValue(values) {
      this.$emit('input', values)
    },
    colorizedSlider() {
      if (!this.colors || this.colors.length === 0) {
        return
      }
      const connects = this.$refs.rangeslider.querySelectorAll('.noUi-connect')
      const connectsLength = connects.length
      for (let i = 0; i < connectsLength; i++) {
        connects[i].classList.add(this.colors[i])
      }
    }
  }
}
</script>
